<template>
  <aside
    :class="[
      'h-full flex flex-col border-r border-md-outline-variant bg-md-surface overflow-auto transition-all duration-300 ease-in-out shrink-0',
      'fixed inset-y-0 left-0 z-50 w-64 lg:relative lg:z-auto',
      open ? 'translate-x-0 lg:w-64 lg:opacity-100' : '-translate-x-full lg:w-0 lg:opacity-0 lg:overflow-hidden',
    ]"
  >
    <!-- Header -->
    <div class="px-4 py-5 flex items-center justify-between">
      <router-link
        to="/"
        class="flex items-center gap-3 text-xl font-medium text-md-on-surface whitespace-nowrap"
      >
        <span
          class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-md-primary-container text-md-on-primary-container"
        >
          QA
        </span>
        <span>.Kit</span>
      </router-link>

      <button
        type="button"
        class="rounded-md p-1.5 text-md-on-surface-variant hover:bg-md-surface-hover shrink-0"
        aria-label="Закрыть меню"
        @click="$emit('toggle')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>
    </div>

    <!-- Nav items -->
    <nav class="flex-1 space-y-0.5 px-3 overflow-auto">
      <router-link
        v-for="item in menuItems"
        :key="item.route"
        :to="item.route"
        class="md-ripple flex items-center rounded-md px-3 py-2.5 text-sm font-medium transition-colors"
        :class="
          isActive(item.route)
            ? 'bg-md-secondary-container text-md-on-secondary-container'
            : 'text-md-on-surface-variant hover:bg-md-surface-hover hover:text-md-on-surface'
        "
      >
        {{ item.label }}
      </router-link>

      <div class="my-2 border-t border-md-outline-variant" />

      <router-link
        v-for="item in menuInfoItems"
        :key="item.route"
        :to="item.route"
        class="md-ripple flex items-center rounded-md px-3 py-2.5 text-sm font-medium transition-colors"
        :class="
          isActive(item.route)
            ? 'bg-md-secondary-container text-md-on-secondary-container'
            : 'text-md-on-surface-variant hover:bg-md-surface-hover hover:text-md-on-surface'
        "
      >
        {{ item.label }}
      </router-link>

      <div class="my-2 border-t border-md-outline-variant" />

      <router-link
        v-for="item in menuLegalItems"
        :key="item.route"
        :to="item.route"
        class="md-ripple flex items-center rounded-md px-3 py-2.5 text-sm font-medium transition-colors"
        :class="
          isActive(item.route)
            ? 'bg-md-secondary-container text-md-on-secondary-container'
            : 'text-md-on-surface-variant hover:bg-md-surface-hover hover:text-md-on-surface'
        "
      >
        {{ item.label }}
      </router-link>
    </nav>
  </aside>
</template>

<script setup lang="ts">
import { menuInfoItems, menuItems, menuLegalItems } from '@/config/tools';
import { useRoute } from 'vue-router';

defineProps<{
  open: boolean;
}>();

defineEmits<{
  toggle: [];
}>();

const $route = useRoute();

const isActive = (route: string) => {
  if (route === '/') return $route.path === '/';
  return $route.path === route;
};
</script>
